import * as React from "react"

import Seo from "../components/Seo"

const normatividadPage = () => (
  <>
    <Seo title="Terminos y Condiciones" />
    <div className="terms">
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>TÍTULO PRIMERO&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>DISPOSICIONES GENERALES</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO I</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>De la institución</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 1.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;El Centro Hidalguense de Estudios Superiores, CENHIES, es una
          Institución Educativa creada por la Sociedad Civil del mismo nombre, cuya
          misión es favorecer la integración de la Sociedad Hidalguense a través del
          cumplimiento de sus objetivos.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 2.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;En uso de las facultades que le otorga el artículo 3° de la
          Constitución Política de los Estados Unidos Mexicanos, la Ley General de
          Educación, sus reglamentos y el acta constitutiva de la Sociedad Civil a
          la que pertenece, realizará sus fines de educar, investigar y difundir la
          cultura de acuerdo con esa normatividad, respetando la libertad de cátedra
          e investigación y libre examen, y discusión de las ideas.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 3.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Para lograr el cumplimiento de la Misión para la que fue creada, se
          fija los siguientes objetivos institucionales:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Impartir educación tendente a la formación de los individuos en las
            áreas del conocimiento que contemplan los planes y programas de
            estudio.&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Difundir la cultura a sus alumnos y a la comunidad en general.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Formar personas, profesionistas e investigadores de relevante calidad
            académica, que se caractericen por el grado de excelencia en su
            quehacer.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Establecer estudios que contribuyan a la satisfacción de las necesidades
            del estado de Hidalgo y del País.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Colaborar en la desconcentración de la enseñanza en el País, atendiendo
            a las necesidades regionales de demanda educativa.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Fortalecer vínculos familiares de los habitantes del estado de Hidalgo,
            al propiciar que sus jóvenes se formen en la misma entidad, sin tener
            que emigrar del mismo.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Incrementar e impulsar la investigación científica y el desarrollo de la
            tecnología.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Propiciar una permanente comunicación con la sociedad que permita la
            satisfacción de sus necesidades educativas y el conocimiento de los
            nuevos requerimientos que en ella se vayan dando.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Orientar el servicio social a fin de que su prestación satisfaga
            efectivamente las necesidades sociales.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Concertar convenios con otras instituciones con el objetivo de
            aprovechar recíprocamente sus capacidades, evitando inversiones
            innecesarias.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Las demás que se deriven de los ordenamientos de la materia.&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 4.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Para poder cumplir con sus objetivos, la Institución establecerá las
          estructuras administrativas y académicas que estime convenientes.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 5.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El Reconocimiento de Validez Oficial de los Estudios que imparte, le dan
          la facultad para expedir todo tipo de documentación que los
          acrediten.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 6.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Los planes de estudios que se impartan tendrán vigencia en todo el
          territorio nacional y en aquellos países con los que México tenga
          convenios educativos, de acuerdo con las leyes y reglamentos de la
          materia.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 7.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Se reconocerán también los estudios realizados en otras instituciones
          educativas nacionales o extranjeras, previa equivalencia o revalidación de
          los mismos por la Secretaría de Educación Pública.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 8.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          De acuerdo con el acta constitutiva de la Sociedad Civil a la que
          pertenece, se nombrarán a las autoridades, funcionarios, personal
          académico, de confianza, administrativo y de servicio de sus diferentes
          áreas académicas, de investigación y de difusión de la cultura.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 9.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          La función docente se realizará en las siguientes carreras:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>Administración de empresas.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Ciencias de la Comunicación.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Derecho.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Contaduría.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Psicología.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Administración de Empresas Turísticas.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>&nbsp;Diseño Gráfico.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Las demás que se establezcan en el futuro.
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO II</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>De los órganos de gobierno</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 10.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>Los órganos de gobierno son:</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify",
          textIndent: "1.0cm"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>Rector.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Director General.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Director Académico y de Planeación.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Director de Control Escolar.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Director de Comunicación Social y Difusión Cultural.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Director de Finanzas.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Director de Recursos Humanos.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Coordinadores.</span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify",
          textIndent: "1.0cm"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 11.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El Rector es la máxima autoridad académica y tiene como funciones:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify",
          textIndent: "1.0cm"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Promover el desarrollo equilibrado de la Institución, impulsando las
            actividades de docencia, investigación y difusión de la cultura.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Elaborar el plan de desarrollo institucional.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Presentar el informe anual sobre el resultado de las actividades
            desarrolladas.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Celebrar los convenios que sean necesarios para el buen funcionamiento
            de la Institución.Acordar periódicamente con el Directos General y con
            los Directores de la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Cumplir y hacer cumplir la normatividad institucional.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            &nbsp;Las demás que le confiera la normatividad.
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 12.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El Director General tiene como funciones:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify",
          textIndent: "1.0cm"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            A falta de Rector, cumplir las funciones de éste.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Auxiliar al Rector en la aplicación de las políticas de las funciones de
            docencia, investigación y desarrollo, extensión y vinculación.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Refrendar con su firma los actos jurídicos celebrados por el Rector.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Firmar, por delegación expresa del Rector, los actos jurídicos que por
            su naturaleza así lo permitan.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Coadyuvar con el Rector al mantenimiento de las relaciones con las
            organizaciones representativas de la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Coordinar los eventos especiales y supervisar que las actividades
            institucionales se realicen conforme a los protocolos establecidos para
            tales efectos.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Planear, coordinar y evaluar las acciones necesarias para asegurar la
            protección integral de la comunidad.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Dirigir las actividades para la atención de los asuntos jurídicos y
            normativos relacionados con la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Coordinar la integración y elaboración del informe anual de la función
            institucional.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            &nbsp;Las demás que le confiera la normatividad.
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textIndent: "-21.3pt"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 13.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El Director Académico y de Planeación tiene como funciones:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify",
          textIndent: "1.0cm"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Coordinar la formulación de políticas institucionales de docencia,
            planeación e investigación, así como supervisar su ejecución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Coordinar la formulación de políticas para el ingreso, promoción,
            permanencia y evaluación del personal académico.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Mantener vigentes los planes y programas de estudios que se imparten en
            la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Gestionar proyectos de innovación pedagógica.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Coordinar los planes de desarrollo institucional.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Dictaminar sobre los proyectos de investigación a realizarse en la
            Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            &nbsp;Fomentar el intercambio y cooperación con investigadores y con los
            organismos que desarrollen investigación científica y tecnológica.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Las demás que le confiera la normatividad.
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 14.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El Director de Control Escolar tiene como funciones:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Gestionar la documentación de los alumnos de la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Procesar las calificaciones, acreditamientos y regularizaciones de los
            estudios de los alumnos.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Emitir los certificados, constancias y validación de estudios.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Coordinar los servicios escolares de la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Las demás que le confiera la normatividad.
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 15.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El Director de Comunicación Social y Difusión Cultural, tiene como
          funciones:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Formular, proponer e implementar las políticas de comunicación,
            relaciones públicas e imagen institucional.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Comunicar eficientemente a la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Asesorar a la Institución en cuanto a relaciones públicas.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Coordinar estrategias de mercadotecnia.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Establecer convenios de cooperación Institucional.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Las demás que le confiera la normatividad.
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 16.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El Director de Finanzas dependerá directamente del Consejo de
          Administración de la Sociedad Civil a la que pertenece, tiene como
          funciones:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify",
          textIndent: "1.0cm"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Coordinar las actividades de obtención y aplicación de los recursos
            financieros.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Promover la aplicación de técnicas adecuadas para la optimización de los
            recursos de la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Supervisar la conservación y control de las instalaciones, material y
            equipo.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Controlar desde el punto de vista financiero los convenios que se
            suscriban.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Las demás que le confiera la normatividad.
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textIndent: "-21.3pt"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 17.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El Director de Recursos Humanos dependerá directamente del Consejo de
          Administración de la Sociedad Civil a la que pertenece, tiene como
          funciones:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Planificar, dirigir, coordinar y evaluar la ejecución de las actividades
            de la oficina de Recursos Humanos, en función a lo establecido en el
            respectivo plan operativo.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Planear la admisión del personal de la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Administrar la remuneración de los colaboradores.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Desarrollar al personal de la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Supervisar al personal de la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Las demás que le confiera la normatividad.
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 18.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Los coordinadores tienen como funciones:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Proporcionar a los alumnos recursos, orientación y apoyo efectivo para
            concretar el perfil de egresados en el plazo establecido.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Mantener una plantilla docente de excelencia y alto nivel.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Gestionar la calidad del proceso educativo curricular.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Vincular a los alumnos en su campo de acción.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Promover actividades docentes que desarrollen al máximo el proceso de
            enseñanza aprendizaje.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Las demás que le confiera la normatividad.
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO III</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>De los planes y programas de estudio</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 19.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Los planes y programas de los estudios que se imparten son los revisados y
          aprobados por las instancias correspondientes de la Secretaría de
          Educación Pública.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          La Institución impartirá, extracurricularmente, cursos de idiomas
          extranjeros, así como cursos básicos de informática.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify",
          textIndent: "17.4pt"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 20.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          La educación que se imparta será escolarizada, en turnos matutino,
          vespertino y mixto.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 21.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Se impartirán cursos de regularización a los alumnos cuya equivalencia de
          estudios, autorizada por las autoridades de la Secretaría de Educación
          Pública, hayan dejado materias pendientes; los que durarán el mismo número
          de horas que hubieran correspondido a la materia pendiente; asimismo, se
          llevarán a cabo fuera de los horarios escolares del alumno, previo acuerdo
          entre éste y la Institución.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 22.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El ciclo escolar se apegará al calendario que autorice la Secretaría de
          Educación Pública, el cual será difundido oportunamente a efecto de que
          sea conocido por alumnos y maestros.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 23.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El avance programático será supervisado durante el ciclo escolar a través
          del control diario del tema que el maestro debe registrar, con la
          verificación ante los propios alumnos, así como con la comparación de los
          conocimientos evaluados en los exámenes con los contenidos programáticos
          de la materia.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 24.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          La evaluación y actualización de los planes y programas de estudio se
          realizarán periódicamente por la academia de catedráticos que hubieran
          impartido la asignatura en el último ciclo escolar, en coordinación con el
          responsable del programa.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 25.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Los planes de estudio que se impartan de las carreras enunciadas en
          el artículo 9 de este Reglamento, tendrán como lapso mínimo de duración el
          previsto para concluir cada una de ellas y como máximo una mitad más.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>TÍTULO SEGUNDO</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO ÚNICO</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>De los docentes</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 26.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Para ser miembro del cuerpo docente de la Institución, se deberán reunir
          los siguientes requisitos:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Contar con título y cédula profesional en un área afín al perfil de la
            asignatura a impartir.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Tener como mínimo cinco años de ejercicio profesional en área afín.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Contar con certificación que avale su actualización docente.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Tener una reputación personal y profesional acorde a la Filosofía
            Institucional.
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 27.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          La relación laboral entre el docente y la Institución se regirá por lo
          dispuesto en el contrato individual de trabajo que para tal efecto
          firmarán al inicio de cada ciclo escolar.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 28.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El perfil que debe reunir cada uno de los integrantes del cuerpo docente,
          obedecerá a las siguientes características:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Ser profesionista que comparta la filosofía de la libertad del
            pensamiento y libre expresión de las ideas, y ser orientador dentro de
            la diversidad para llegar a la unidad del conocimiento.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Poseer elevada preparación disciplinar y experiencia en su área.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Poseer formación y experiencia en el campo de la transmisión del
            conocimiento.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Conducirse con responsabilidad y seriedad en el desempeño de sus
            actividades académicas, de manera que sea ejemplo a seguir por sus
            alumnos.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Difundir la política educativa de la Institución.&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 29.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          A efecto de permanecer en el cuerpo docente de la Institución, los
          integrantes de este deberán demostrar plena capacidad en el ejercicio de
          sus funciones y disposición para colaborar a través del proceso
          enseñanza-aprendizaje en la formación de sus alumnos.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 30.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Las funciones genéricas que desempeñarán los docentes serán:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Impartir la educación contemplada en el programa de su asignatura.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Prestar asesoría y/o tutoría a los alumnos.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Realizar investigación científica.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Realizar actividades de extensión y difusión.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Las demás que les sean encomendadas.&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify",
          textIndent: "1.0cm"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 31.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Las categorías del personal académico serán:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify",
          textIndent: "1.0cm"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>Profesor por horas.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Profesor de medio tiempo.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Profesor de tiempo completo.</span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify",
          textIndent: "1.0cm"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 32.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          A los profesores por horas les corresponde:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Impartir la educación contemplada en el programa de su asignatura.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Elaborar y aplicar exámenes con oportunidad.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Propiciar con su quehacer el interés y motivación en los alumnos por la
            ciencia y la investigación.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Realizar sus funciones dentro del horario de clase establecido.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Informar anticipadamente a la coordinación de cualquier actividad que se
            pretenda realizar, recabando la autorización correspondiente.&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify",
          textIndent: "1.0cm"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 33.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          A los docentes de medio tiempo les corresponde:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Desempeñar la función académica que les haya sido asignada en un horario
            diario mínimo de 4 horas.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Prestar asesoría y/o tutoría a alumnos o grupos.
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify",
          textIndent: "1.0cm"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify",
          textIndent: "1.0cm"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 34.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          A los docentes de tiempo completo les corresponde:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Desempeñar la función académica que les haya sido encomendada en un
            horario mínimo de 8 horas, hora, semana, mes.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Prestar como mínimo 4 horas frente a grupo en el desarrollo de los
            programas que estén a su cargo.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Desarrollar la función permanente de asesor, tutor y/o coordinador en el
            plan de estudios a que esté asignado.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Realizar labores de investigación, de acuerdo con los programas que para
            ese efecto se hayan aprobado.&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 35.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          La Institución proveerá a los profesores de los medios de apoyo necesarios
          para el ejercicio de sus funciones, con la condición de que se justifique
          su implementación, que sean congruentes con los programas y que se
          soliciten con la debida anticipación.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 36.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Se promoverán los convenios interinstitucionales que sean necesarios
          para dar sustento al quehacer educativo y que sean tendentes a la
          actualización, difusión y fomento de la ciencia y la cultura.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 37.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Los docentes, independientemente de la categoría que ocupen, gozarán de
          los siguientes derechos:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Los contenidos en el contrato individual de trabajo firmado con la
            Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Asistir a los cursos de actualización y seminarios que sean
            implementados por la Institución para mejorar su formación disciplinar y
            pedagógica.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Asistir a cursos promovidos por instituciones diversas, siempre y cuando
            tengan relación directa con la formación profesional docente.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Las demás que les confiera la normatividad.
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>TÍTULO TERCERO</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>DE LOS ALUMNOS</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO I</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>De la selección y admisión&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 38.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Para ingresar como alumno de la Institución, los interesados deberán
          sujetarse al proceso de selección que con este fin se lleve a cabo, así
          como cumplir con las demás condiciones y requisitos que se establezcan con
          el mismo propósito.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 39.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Para tener derecho a participar en el proceso de selección y poder
          ingresar a la Institución, se requiere:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Haber terminado íntegramente el nivel educativo anterior, sin adeudar
            materias.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Tener un promedio mínimo general, comprobable, de 6.0 (seis) en el ciclo
            educativo inmediato anterior.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Presentar a la Dirección de Control Escolar la siguiente documentación
            original, según sea el caso:
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>Certificado de Educación Básica.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Certificado de Educación Media Superior (Bachillerato) o equivalente,
            debidamente legalizado por las autoridades respectivas.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Copia certificada del acta de nacimiento.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>CURP.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Seis fotografías, tamaño infantil, de frente.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Comprobante de haber cubierto las cuotas y derechos estipulados.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Equivalencia de estudios, en su caso.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Revalidación de estudios para alumnos extranjeros, quienes deberán
            presentar además, sus documentos oficiales apostillados.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Calidad migratoria.</span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          En los casos de equivalencia y revalidación, el alumno podrá optar por
          realizar los trámites por cuenta propia, ante las autoridades competentes.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 40.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          La selección de alumnos se hará con base exclusivamente en aspectos
          académicos.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px", fontFamily: '"Times New Roman",serif' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px", fontFamily: '"Times New Roman",serif' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO II</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>De las inscripciones&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 41.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Es alumno de la Institución quien se encuentre inscrito y haya cumplido
          con los requisitos exigidos para ese efecto.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          El simple hecho de iniciar trámites de inscripción sin concluirlos no
          confiere la condición de alumno ni derecho alguno.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 42.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Para obtener inscripción el interesado deberá acreditar:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Haber sido aceptado de acuerdo con el proceso de selección.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Haber presentado completa la documentación requerida por la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Presentar los recibos que acrediten haber cubierto el pago de
            inscripción, colegiatura y demás cuotas estipuladas.&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 43.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Los documentos que acompañe el solicitante al inscribirse formarán parte
          del expediente que la Dirección de Control Escolar llevará de cada alumno
          y solo podrán ser devueltos a cambio de copias fotostáticas debidamente
          cotejadas y certificadas por Notario Público.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 44.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Las constancias de estudios solamente serán admitidas cuando consten las
          materias cursadas y las calificaciones obtenidas, para efecto de iniciar
          trámites de inscripción y hasta por un término máximo de un semestre,
          contado a partir de la inscripción; transcurrido el cual deberá
          presentarse el certificado correspondiente y en caso contrario, quedará
          sin efecto el trámite iniciado.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 45.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          La inscripción o reinscripción se considera legal cuando el alumno reciba
          su credencial o tira de materias, la cual contendrá las asignaturas que el
          alumno tiene la obligación y derecho de cursar, así como el o los grupos a
          los que deberá asistir.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 46.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Con la debida anticipación se difundirá el período de inscripciones o
          reinscripciones de los diversos planes de estudios.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          El alumno que no se reinscriba en dicho período causará baja temporal para
          ese curso lectivo.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 47.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Los alumnos que durante el período señalado para la inscripción y
          reinscripción no concluyan dicho trámite, se entiende que renuncian tanto
          a efectuar tal gestión como a la devolución de las cuotas que hayan
          cubierto.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 48.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          No se aceptará o en su caso, se cancelará la inscripción, en las
          siguientes hipótesis:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Cuando no se cumplan los requisitos que señala la normatividad.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Cuando se presenten documentos falsos o alterados, en cuyo caso se
            inhabilitará al interesado para volver a ingresar a cualquier plan de
            estudios de la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Cuando se compruebe que el interesado ha sido expulsado definitivamente
            de alguna otra Institución educativa.&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 49.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Las asistencias e inasistencias se computarán desde que se inicie el curso
          respectivo, debiendo el catedrático registrarlas obligatoriamente en las
          listas oficiales autorizadas para tal fin, no habiendo retardos.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 50.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El alumno que se inscriba extemporáneamente, cualquiera que sea la causa,
          se le computará como inasistencias todas las clases transcurridas desde la
          iniciación del curso hasta la fecha de su inscripción.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 51.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          La distribución de la población escolar se hará en grupos conforme a la
          modalidad establecida en la Institución, a las posibilidades de esta y a
          los criterios académicos adoptados para cada plan de estudios.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO III</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>
            De los derechos y obligaciones de los alumnos
          </span>
        </strong>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 52.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          La calidad de alumno otorga todos los derechos e impone las obligaciones
          que los reglamentos establecen.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          El ingreso a la Institución compromete al alumno a acatar los acuerdos y
          disposiciones normativas correspondientes. &nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 53.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Los alumnos de la Institución tienen los siguientes derechos:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Recibir educación en igualdad de oportunidades, conforme a los programas
            educativos.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Recibir el número de sesiones previstas en la carga académica
            correspondiente.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Participar en los programas de becas, tutorías y asesoría sobre el
            contenido de los programas educativos y los servicios que presta la
            Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Ser evaluados conforme a los programas educativos correspondientes.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Obtener los documentos que acrediten su condición de alumno
            (constancias, certificados, credencial, comprobante de inscripción).
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Utilizar las instalaciones y demás espacios Institucionales conforme a
            la normatividad aplicable.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Expresar libremente sus ideas, en forma respetuosa, sin alterar el orden
            y disciplina de la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Ser respetado por los miembros de la comunidad institucional.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Realizar los trámites administrativos a través de tercera persona con
            poder suficiente.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Recibir respuesta por escrito, en tiempo y forma, a las solicitudes y
            trámites administrativos.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Recibir copia del Reglamento escolar sellado por la Secretaría de
            Educación Pública.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Los demás que deriven de este reglamento y demás normatividad de la
            Institución.
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 54.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Los alumnos de la Institución tienen las siguientes obligaciones:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Ser responsables de su proceso de formación académica.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Practicar y fomentar los principios y valores institucionales.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Observar y respetar las disposiciones de la normatividad institucional.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Efectuar de manera precisa y oportuna los trámites escolares que le
            correspondan.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Obtener al inicio del periodo escolar, el comprobante de inscripción.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Cumplir con todos los requisitos y actividades académicas del programa
            educativo correspondiente.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Concluir sus estudios en el programa educativo vigente a la fecha de su
            ingreso.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Cumplir y participar en sus actividades académicas provistos de los
            instrumentos y materiales necesarios para el buen desarrollo de las
            mismas.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Sustentar las evaluaciones dentro de los periodos y con las condiciones
            establecidas.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Evitar la participación en actos o hechos que dañen los principios y
            valores institucionales o el correcto desarrollo de las actividades
            institucionales.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Respetar a los miembros de la comunidad institucional y a los
            visitantes.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Cubrir el pago de derechos por los servicios que solicita a la
            institución, en los montos y periodos aprobados.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Solicitar por escrito cualquier trámite.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Las demás que señale la normatividad institucional.
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textIndent: "49.65pt"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 55.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Son actos que vulneran los principios y valores institucionales los
          siguientes:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Incitar o participar dentro de la Institución, o perturbar el desarrollo
            normal de las actividades institucionales.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Utilizar las instalaciones para uso o fines distintos de aquellos a los
            que estén destinadas.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Faltar al respeto, hostilizar o utilizar la violencia en contra de
            cualquier miembro de la comunidad institucional.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Destruir, alterar, dañar intencionalmente o apoderarse del patrimonio de
            la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Cometer actos contrarios a la moral o al respeto que entre sí se deben
            los miembros de la comunidad institucional, incluyendo los de bullying,
            acoso escolar o sexual.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Prestar o recibir ayuda fraudulenta en el desarrollo de sus actividades
            académicas y administrativas, e incurrir en plagios académicos.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Falsificar o alterar documentos oficiales o utilizarlos indebidamente,
            con independencia de que se ejerza la acción legal que corresponda.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Engañar a los miembros de la comunidad institucional o aprovecharse de
            ellos para obtener beneficios en forma ilícita.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Utilizar sin la autorización debida el nombre, lema o logotipo de la
            Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Portar armas dentro de la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Distribuir o consumir psicotrópicos, estupefacientes o bebidas
            alcohólicas en la Institución, o concurrir a ella en estado de ebriedad
            o bajo los efectos de alguna droga o estimulante.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Organizar y participar en juegos de azar sin previo permiso, dentro de
            las instalaciones de la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Las demás que señale la normatividad institucional.
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 56.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Las sanciones por los actos señalados en el artículo anterior se aplicarán
          conforme a la normatividad institucional y pueden ser las siguientes:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>Amonestación por escrito.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Reposición o sanción económica hasta por el doble del costo del material
            o bien propiedad de la Institución que haya sido dañado.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Suspensión temporal en sus derechos institucionales hasta por seis
            meses, según la gravedad de la falta cometida.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Anulación de las calificaciones obtenidas fraudulentamente.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Cancelación de la inscripción.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Baja definitiva de la Institución.</span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 57.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Los alumnos y los particulares podrán presentar queja por deficiencia en
          la prestación del servicio educativo de la Institución, incluso por casos
          de bullying, acoso escolar o sexual, ante el Director General quien
          resolverá y seguirá el procedimiento previsto en el artículo 59 de este
          Reglamento.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center",
          textIndent: "1.0cm"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO IV</span>
        </strong>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center",
          textIndent: "1.0cm"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center",
          textIndent: "1.0cm"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>Del recurso de inconformidad</span>
        </strong>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 58.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El recurso de inconformidad podrá ser interpuesto cuando el alumno
          considere que:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Se han vulnerado sus derechos institucionales, en cuyo caso el recurso
            se interpondrá de manera inmediata, o&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            El registro de los resultados obtenidos en su carga académica sea
            inadecuado, en cuyo caso podrá interponer el recurso dentro de los diez
            días hábiles siguientes a la conclusión del periodo escolar.
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          La solicitud deberá ser presentada por escrito al coordinador del programa
          de que se trate señalando las causas.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 59.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El Director General será el responsable de resolver la inconformidad,
          desahogará el recurso dentro de los cinco días hábiles siguientes a la
          presentación del mismo y notificará el resultado al interesado dentro de
          los tres días hábiles siguientes.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO V</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>De la permanencia y reinscripciones</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 60.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;La permanencia de los alumnos en los programas educativos está
          sujeta al cumplimiento del proceso de reingreso.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 61.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          La reinscripción de los alumnos solo se efectuará dentro del período
          señalado para tal efecto, previo cumplimiento de los requisitos
          siguientes:
        </span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Presentar original de la credencial o tira de materias del semestre
            anterior al que se pretenda la reinscripción.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Comprobante de haber cubierto las cuotas y derechos establecidos y no
            tener adeudos.
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 62.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Cuando se trate de reinscripción, de darse el caso, únicamente se tendrá
          que complementar el expediente del interesado en los términos de las
          fracciones I y III, del artículo 39 de este Reglamento.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 63.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Los alumnos reinscritos quedarán sujetos al cumplimiento de la
          normatividad de la Institución y además a las siguientes reglas:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Pasarán como alumnos regulares al ciclo inmediato superior quienes,
            conforme al plan de estudios, hayan aprobado la totalidad de las
            materias del ciclo anterior.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Pasarán como alumnos irregulares al ciclo inmediato superior, quienes
            adeuden hasta 3 materias, habiendo cursado de 4 a 6, o hasta 4 cuando
            hayan cursado 7 o más asignaturas.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Los alumnos que adeuden más del número de materias señaladas en el
            artículo anterior, no podrán reinscribirse al ciclo escolar superior
            teniendo que repetir el curso en las materias que adeuden.
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 64.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Los alumnos que por baja temporal hayan interrumpido sus estudios, podrán
          reinscribirse, si el cupo de los grupos lo permite, de acuerdo con los
          siguientes lineamientos:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Si la interrupción fue por un lapso hasta de cuatro años y el plan de
            estudios sigue vigente, podrán reinscribirse sin más trámite que la
            autorización de la Dirección de Control Escolar.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Si la interrupción fue por un lapso de cuatro años y el plan de estudios
            ha sido modificado, tendrán que solicitar equivalencia o revalidación de
            estudios, y se inscribirán en el que corresponda, según el dictamen que
            se emita.&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 65.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Los plazos a que hace mención el artículo anterior, se computarán a partir
          de la fecha en que se haya sustentado el último examen.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO VI</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>De la situación escolar del alumno</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 66.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>Los alumnos pueden ser:</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>Regulares</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Irregulares</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Pasantes</span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 67.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Son alumnos regulares, los que están inscritos en un ciclo escolar sin
          adeudar materia de ciclos anteriores.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 68.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Son alumnos irregulares, los repetidores y los que adeudan materias de
          ciclos anteriores.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 69.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Son pasantes, los alumnos regulares inscritos en el séptimo cuatrimestre
          de una carrera profesional.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO VII</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>De los cambios de grupo o materia</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 70.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Las solicitudes de cambio de grupo deberán presentarse en la
          Dirección de Control Escolar y su aprobación estará sujeta al cupo de
          ellos.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 71.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Únicamente se autorizará el cambio de grupo en el lapso comprendido
          entre el período de inscripción y reinscripción y la segunda semana de
          clases.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO VIII</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>De las bajas&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 72.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>&nbsp;Los alumnos causarán baja:</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>A solicitud del interesado.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Por bajo rendimiento escolar.&nbsp;</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Por abandono de estudios.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Por mala conducta reiterada o grave.</span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 73.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Los alumnos causarán baja voluntaria, en forma temporal o
          definitiva, cuando se solicite por escrito presentado ante la Dirección de
          Control Escolar, identificándose satisfactoriamente y haciendo la mención
          de si la baja es temporal o es definitiva.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 74.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;En el caso que señala el artículo 64 de este Reglamento, la baja
          temporal se dará en forma automática, comunicándoselo por escrito al
          interesado y/o al padre o tutor.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 75.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Causarán baja definitiva por bajo rendimiento escolar, los alumnos que se
          encuentren en los siguientes casos:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Cuando hayan agotado las oportunidades reglamentarias para regularizarse
            y aún adeuden una o más materias.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Cuando hubiere transcurrido el plazo máximo de dos ciclos para
            regularizarse y aún adeuden una o más materias.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Cuando reprueben en diferentes ciclos escolares más de doce exámenes
            ordinarios del correspondiente plan de estudios.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Cuando reprueben en tres ocasiones la misma materia, después de haberla
            recursado y presentado los exámenes ordinarios, extraordinarios o
            especiales.&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 76.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Ningún alumno podrá inscribirse o reinscribirse por más de dos ocasiones
          en un mismo semestre o asignatura, haya o no, presentado exámenes
          extraordinarios.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 77.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Causarán baja temporal en el semestre, los alumnos que estando inscritos
          abandonen sus estudios durante tres meses consecutivos.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 78.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Causará baja definitiva por mala conducta, el alumno que cometa faltas
          reiteradas o graves, calificadas por el Director General, como resultado
          de previa investigación de los hechos, con audiencia de parte.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 79.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Las únicas autoridades que por una sola ocasión podrán ampliar lo
          dispuesto en los artículos 75 y 76, son el Director General conjuntamente
          con el Director de Control Escolar, sujetándose a las siguientes
          condiciones:
        </span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Que el interesado lo solicite por escrito.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Que el peticionario tenga un promedio general no menor de 6.0 (seis)
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Que el alumno no tenga notas desfavorables por mala conducta.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Que la causa que haga valer el interesado esté suficientemente
            justificada.&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 80.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El dictamen que sobre esos casos se emita, será definitivo y recurrible.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 81.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El alumno que obtenga un dictamen favorable, deberá sujetarse para la
          regularización a los calendarios oficiales establecidos y bajo las
          condiciones señaladas para el caso.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO IX</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>De la movilidad&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 82.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          La movilidad nacional e internacional de los alumnos se sujetará a la
          normatividad institucional, los acuerdos, convenios y demás disposiciones
          aplicables.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 83.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Para que un alumno pueda cursar su carga académica en diferentes programas
          educativos de la Institución deberá:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Reingresar el periodo escolar correspondiente.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Solicitar autorización de la compartición de asignaturas a la Dirección
            de Control Escolar, dentro del periodo de reinscripciones.
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 84.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Para que un alumno de la Institución pueda cursar su carga académica en
          otra Institución deberá cumplir los siguientes requisitos:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Reingresar al periodo escolar y registrar su carga académica
            correspondiente, y&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Entregar a la Dirección de Control Escolar, previamente a la realización
            de la movilidad, la carta de autorización expedida por la Coordinación
            correspondiente.
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 85.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          La carga académica cursada en otra institución será reconocida siempre y
          cuando los resultados obtenidos sean validados por la Dirección de Control
          Escolar, con base en el documento oficial expedido por la institución
          externa.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 86.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Para que un alumno de otra institución pueda realizar estudios en la
          Institución deberá cumplir con los siguientes requisitos:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Obtener la autorización de movilidad.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Entregar a la Dirección de Control Escolar, la carta de aceptación de
            esta Institución al momento de inscribirse.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Sujetarse a las disposiciones académicas establecidas en la normatividad
            Institucional, el programa educativo y los convenios respectivos.
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>TÍTULO CUARTO&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>DE LAS EVALUACIONES</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO I</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>De las formas de evaluación</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 87.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          La evaluación del aprendizaje de los alumnos se efectuará a través de los
          siguientes tipos de examen:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>Examen parcial.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Examen ordinario.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Examen extraordinario.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Examen especial</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Examen por derecho de pasantía.</span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 88.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El derecho a examen parcial u ordinario será otorgado por la Dirección de
          Control Escolar, a quien tenga derecho con base en el porcentaje de
          asistencia que aparezca en las listas oficiales.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 89.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Para aprobar una asignatura, los alumnos tendrán derecho a presentar los
          exámenes señalados en las fracciones I, II, III y IV del artículo 87,
          sujetándose a su orden.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 90.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El plazo máximo para que un alumno quede regularizado es de dos ciclos
          escolares, contados a partir de la fecha de presentación del último examen
          del curso ordinario.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 91.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          La escala de calificaciones será numérica del 0 al 10, expresada en
          enteros. El alumno acreditará las asignaturas cuando obtenga calificación
          mínima de 6.0 (seis) o más.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 92.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Cuando el alumno no presente examen, el catedrático asentará en el acta
          respectiva las siglas N.P., que significan: no se presentó.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 93.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Los coordinadores de los diversos planes de estudios serán responsables de
          que los exámenes se lleven a cabo de acuerdo a las formalidades que señala
          este Reglamento y los demás ordenamientos aplicables.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 94.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El catedrático dispondrá de un plazo improrrogable de 3 días para entregar
          las actas de examen a la coordinación respectiva, contados a partir de la
          fecha de su celebración.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 95.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Cuando un alumno esté inconforme con su calificación, podrá solicitar la
          revisión de examen ante la coordinación correspondiente, dentro del plazo
          de 2 días a partir de la comunicación de los resultados.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          Transcurrido el término a que se hace mención, se tendrá por aceptada la
          calificación y no podrá ser modificada.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO II</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>
            De los exámenes parciales y ordinarios&nbsp;
          </span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 96.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Examen parcial es aquel que se celebra al finalizar cada mes del ciclo
          escolar, y se aplicará en cada asignatura que comprenda el plan de
          estudios.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          El examen ordinario es aquel que se celebra al finalizar el ciclo escolar
          correspondiente y se aplicará en cada asignatura que comprenda el plan de
          estudios.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 97.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Tendrán derecho a presentar examen parcial u ordinario los alumnos que
          cumplan los siguientes requisitos:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Estar debidamente inscritos en la asignatura de que se trate.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Acreditar un mínimo del 80% de asistencias a las clases programadas en
            el curso respectivo.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Que se encuentren enlistados en las actas de examen.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Que las asignaturas en las que se van a examinar estén autorizadas en su
            tira de materias.
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO III</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>De los exámenes extraordinarios</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 98.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Examen extraordinario es aquel que se concede al alumno que teniendo
          derecho a examen ordinario, haya reprobado este, no lo haya presentado o
          no haya tenido derecho a presentarlo por no haber acreditado el número de
          asistencias prevista en la fracción II, del artículo anterior.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 99.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          No tendrán derecho a presentar este examen, quienes no hayan cursado la
          asignatura teniendo la obligación de cursarla.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 100.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Para tener derecho a examen extraordinario deberán reunirse los siguientes
          requisitos:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Estar debidamente inscritos en el ciclo en que se solicite.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Acreditar un mínimo del 60% de asistencias a las clases programadas en
            el curso respectivo, del ciclo escolar inmediato anterior.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            No adeudar más del número de asignaturas previsto en la fracción II, del
            artículo 63 de este Reglamento.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Cubrir los derechos una vez que sea autorizada la solicitud de
            examen.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Registrarse en la Dirección de Control Escolar con 48 horas de
            anticipación a la celebración del examen, para ser enlistado en actas.
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 101.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          En las materias teórico-prácticas solo se concederá examen extraordinario
          cuando el alumno haya acreditado las prácticas correspondientes.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 102.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El alumno que repruebe un examen extraordinario o no lo haya presentado
          habiéndolo solicitado, tendrá la oportunidad de solicitar examen especial
          o bien la opción de recursar la materia.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO IV</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>De los exámenes especiales&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 103.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Examen especial es aquel que permite regularizarse al alumno, cuando
          habiendo tenido derecho a examen ordinario y/o extraordinario, no obtenga
          calificación aprobatoria o no los haya presentado.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 104.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Tendrán derecho a presentar exámenes especiales los alumnos que así lo
          soliciten ante la Dirección de Control Escolar, debiendo reunir los
          siguientes requisitos:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Estar debidamente inscritos en el ciclo escolar en que se solicite.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Acreditar un mínimo del 50% de asistencia a las clases programadas en el
            curso respectivo del ciclo escolar inmediato anterior.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            No adeudar más del número de asignaturas previstas en la fracción II,
            del artículo 63 de este Reglamento.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Cubrir los derechos, una vez que le sea autorizada la solicitud de
            examen.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Registrarse en la Dirección de Control Escolar con 48 horas de
            anticipación a la celebración del examen, para ser enlistado en
            actas.&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 105.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;En las materias teórico-prácticas, solo se concederá examen especial
          cuando el alumno haya acreditado las prácticas correspondientes.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 106.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp; El examen especial será siempre escrito y versará sobre todo el
          contenido programático de la asignatura.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 107.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp; El alumno que repruebe examen especial o no lo haya presentado
          habiéndolo solicitado, tendrá la oportunidad de recursar la materia, en el
          caso en que sea procedente.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 108.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Cuando por cambios en el plan de estudio los alumnos queden
          irregulares, podrán regularizarse presentando exámenes especiales.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          Si es por equivalencia de estudios, los alumnos tendrán que cursar las
          asignaturas de acuerdo al plan y programa autorizados por la Secretaría de
          Educación Pública de Hidalgo.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO V</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>Examen por derecho de pasantía&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 109.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp; El derecho de pasantía se concede a los alumnos que habiendo
          terminado un ciclo profesional queden adeudando hasta 2 materias, mismas
          que podrán acreditar con un examen que deberán presentar dentro de los 4
          años posteriores a que hayan sustentado el último examen del plan de
          estudios.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 110.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp; Para presentar examen por derecho de pasantía el alumno deberá
          llenar los siguientes requisitos:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Que haya estado inscrito como alumno.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Que haya cursado las materias cuyo examen se solicite.
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 111.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp; &nbsp;El examen por derecho de pasantía será sustentado ante un
          jurado compuesto por el Presidente de la Academia respectiva y otro
          maestro de la materia designado por el Coordinador respectivo.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 112.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Transcurrido el término a que hace referencia el artículo 109 se
          estará a lo dispuesto por el artículo 64 de este Reglamento.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp;&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>TÍTULO QUINTO&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>DEL EGRESO</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO I</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>
            De los documentos que acreditan los estudios
          </span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 113.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>&nbsp;Son pasantes:</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Los alumnos regulares que reingresen a partir del antepenúltimo periodo
            escolar, o
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Los egresados que no tengan más de un año de haber concluido los
            estudios.
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textIndent: "1.0cm"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          Con excepción de los programas educativos que estipulen lo contrario.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 114.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;La carta de pasante se expedirá a petición del interesado solo para
          efectos del ejercicio profesional, de conformidad con las leyes
          respectivas; tendrá una vigencia de dos años y medio, contada a partir de
          que se adquiere la pasantía.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 115.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Se considera egresado al alumno que concluye el programa educativo
          al cual se inscribió.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 116.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Una vez concluidos los estudios en cualquier periodo escolar o la
          totalidad del programa educativo correspondiente, se emitirá a los alumnos
          que así lo requieran el documento que acredite sus estudios realizados en
          las Institución.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 117.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Los documentos que acreditan los estudios en la institución son:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>Constancia de estudios.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Certificado.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Título profesional.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Cédula profesional.</span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 118.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;La Institución tramitará ante las autoridades competentes el
          registro del título profesional, además de la expedición de la
          correspondiente cédula profesional.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO II</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>
            De las formas de titulación y de los exámenes recepcionales&nbsp;
          </span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 119.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Se establecen las siguientes formas de titulación previo servicio
          social:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>Por tesis.&nbsp;</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Por examen general de conocimientos.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Por realización de estudios de posgrado.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Por demostración de experiencia profesional.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Por informe sobre el Servicio Social prestado.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Por examen general de conocimientos realizado por CENEVAL.
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textIndent: "-21.3pt"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 120.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El examen recepcional se concederá a los alumnos que hayan aprobado la
          totalidad de las asignaturas del plan de estudios cursado, hayan prestado
          el servicio social correspondiente y no excedan más de 3 años de haber
          concluido el 100% de créditos del programa.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          Si por causas debidamente justificadas el alumno no presenta el examen
          recepcional dentro del plazo de 3 años, dirigirá oficio al Director de
          Control Escolar, quien por única ocasión, concederá un plazo improrrogable
          de 6 meses más, para la culminación del mismo.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px", color: "red" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 121.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Para obtener la titulación y el título respectivo, el pasante deberá
          presentar ante la Dirección de Control Escolar:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Solicitud por escrito con 30 días hábiles anteriores a la fecha probable
            de la ceremonia de titulación o examen recepcional, en su caso.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Certificado de la carrera con calificaciones y promedio.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Certificados de secundaria y preparatoria o equivalente, debidamente
            legalizados por la Secretaría de Educación Pública o la instancia
            correspondiente.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Certificado total de estudios de especialidad o certificado parcial con
            45% de los créditos de maestría.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Constancia de haber cumplido satisfactoriamente el servicio social,
            expedida por la Dirección General de Profesiones de la Secretaría de
            Educación Pública.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Constancia de haber obtenido nivel intermedio en la certificación del
            idioma inglés, otorgada por el Centro de Idiomas de la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Copia certificada del acta de nacimiento.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Original vigente de la carta de pasante.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Seis fotografías tamaño título, seis fotografías tamaño filiación y doce
            fotografías óvalo tamaño mignón, todas de frente, en papel mate
            adherible.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Constancia de no adeudar libros a la biblioteca de la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Constancia de no adeudo de aparatos, herramientas, materiales o
            instrumental de laboratorio, expedida por el jefe del área
            correspondiente.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Recibo del pago de los derechos que genere la revisión de estudios.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Recibo del pago de la cuota correspondiente por examen recepcional.
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 122.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Para la expedición de certificados parciales o totales el alumno
          deberá cumplir los siguientes requisitos:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Presentar la solicitud respectiva ante la Dirección de Control Escolar.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Seis fotografías tamaño óvalo, todas de frente.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Recibo del pago de los derechos que genere la revisión de estudios.
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textIndent: "-21.75pt"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 123.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Para sustentar examen recepcional mediante la elaboración de tesis
          es necesario presentar:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Todos los requisitos que señala el artículo 121.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Oficio con el nombre del jurado asignado, expedido por el Coordinador
            del plan de estudios.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Oficio expedido por el jurado respectivo, en el que se autorice la
            impresión del trabajo de tesis.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Diez ejemplares impresos del trabajo.
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 124.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Para sustentar examen recepcional mediante tesis, es necesario elaborar
          una disertación escrita de cien o ciento veinte cuartillas, que versará
          sobre temas y propuestas originales del conocimiento o bien, sobre la
          ampliación, perfeccionamiento, cuestionamiento o aplicación del
          conocimiento existente en el área científica o técnica de la profesión y
          deberá desarrollarse con rigor metodológico.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          La elaboración de la tesis tendrá como plazo máximo el de seis meses
          contados a partir de que sea autorizado el protocolo de investigación y
          designado asesor de la misma.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          El trabajo podrá ser individual o colectivo (máximo 3 integrantes) y con
          un enfoque disciplinario o multidisciplinario.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          El día del examen los miembros del jurado harán una réplica individual de
          la tesis.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          La conceptualización e instrumentación particular de cada tesis será
          objeto de supervisión por parte de la Institución.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 125.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Para sustentar examen general de conocimientos que sea oral y escrito, el
          alumno deberá presentar:&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Todos los requisitos que señala el artículo 121.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Oficio expedido por la Coordinación, con el nombre de los integrantes
            del jurado asignado.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Dicho examen habrá de evaluar una muestra representativa de los
            conocimientos adquiridos.&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          En esta opción, la Institución elaborará una guía para la realización del
          examen y muestras tipo del instrumento de evaluación. Dichos documentos
          serán entregados al alumno con un mínimo de 40 días hábiles de
          anticipación.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          El examen habrá de evaluar una muestra representativa de los conocimientos
          adquiridos.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify",
          textIndent: "35.4pt"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          El jurado elaborará un informe sobre las preguntas y problemas que le
          fueron planteados al sustentante en el caso del examen oral.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify",
          textIndent: "35.4pt"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          Finalmente, los informes y los exámenes deberán ser conservados por la
          Institución por un lapso no menor a seis meses.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 126.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El jurado de este tipo de examen recepcional se integrará por tres
          catedráticos designados por el Coordinador y formarán parte catedráticos
          de materias afines al contenido del temario o trabajo.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 127.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Para obtener la titulación por realización de estudios de posgrado, el
          pasante deberá presentar:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify",
          textIndent: "-1.0cm"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Todos los requisitos que señala el artículo 121.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Plan de estudios de la especialidad o maestría, donde se especifique la
            totalidad de las materias y créditos que la conforman, expedida por la
            Institución de donde proceda, con un mínimo de 45 créditos.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Certificado total de la especialidad o parcial de la maestría donde se
            especifique el número de créditos obtenidos, que deberán ser cuando
            menos 45, así como las calificaciones, con un promedio mínimo de 8.0
            (ocho), expedido por la Institución de donde proceda.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Se integrará un Sínodo de 3 miembros que avalen la pertinencia de los
            estudios de posgrado, quienes asentarán en el acta de titulación el
            nivel y el nombre del programa cursado, la Institución y el período de
            realización.&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 128.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Cuando proceda la titulación por estudios de posgrado, con la concurrencia
          del Director General, del Director de Servicios Escolares y del
          Coordinador correspondiente, el día y hora señalados se realizará la
          ceremonia, en la cual, quien funja como Presidente, dará lectura al acta
          en donde deberá quedar asentado que se reúnen los requisitos del caso, se
          tomará la protesta de Ley y se entregará al interesado la constancia
          correspondiente.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 129.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Para sustentar examen recepcional por demostración de experiencia
          profesional, el pasante deberá presentar:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Todos los requisitos que señala el artículo 121.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Autorización provisional de la Dirección General de Profesiones para
            ejercer y poder optar por esta vía.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Oficio con el nombre del Jurado asignado, expedido por la Coordinación
            correspondiente.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Un informe escrito con sesenta cuartillas cuando menos, elaborado
            individualmente sobre la experiencia profesional del sustentante en el
            área del conocimiento en que se ubica el programa académico, cuya
            duración no deberá ser menor de 2 ni mayor de 3 años.
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          El informe presentado deberá estar avalado por la Institución, empresa u
          organismo donde se realizaron las actividades y por la Institución
          mediante un dictamen de la Dirección Académica, en el que se considerará
          la calidad y veracidad del informe.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify",
          textIndent: "35.4pt"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 130.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Aprobado el informe, el aspirante deberá sustentar una réplica en un
          examen recepcional con un jurado integrado por 3 sinodales.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          La réplica versará sobre el contenido del trabajo o informe. Cada miembro
          del jurado tendrá un máximo de 30 minutos para la réplica correspondiente.
          En caso de examen multidisciplinario, los sustentantes podrán consultarse
          entre sí para la ampliación o aclaración que corresponda.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 131.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Para sustentar examen recepcional por informe sobre el servicio
          social, el pasante deberá presentar:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify",
          textIndent: "-21.0pt"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Todos los requisitos que señala el artículo 121.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Oficio con el nombre del jurado asignado, expedido por la Coordinación
            correspondiente.
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          El informe será escrito en el que se describan y evalúen las actividades y
          resultados del servicio social en relación con el aprendizaje alcanzado y
          deberá contribuir al análisis y solución de un problema específico y a la
          obtención de un beneficio social.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          El informe podrá ser individual o con un máximo de 3 integrantes.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>
          En el examen recepcional, deberá presentarse réplica individual ante un
          jurado de 3 sinodales.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 132.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Se entiende por trabajo interdisciplinario el desarrollado sobre una misma
          área o disciplina, en el que intervienen un mínimo de 2 pasantes.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 133.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Se entiende por trabajo multidisciplinario el desarrollado,
          conjuntamente, por pasantes de las diferentes carreras que se impartan.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 134.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Cuando proceda la titulación por examen general de conocimientos
          realizados por CENEVAL, el alumno deberá presentar los documentos
          expedidos por esa Institución que demuestren que obtuvo un mínimo
          aprobatorio de 1000 (un mil) puntos de la escala del índice de ese
          organismo; y reunir todos los requisitos señalados en el artículo 121 de
          este Reglamento, los cuales presentará ante la Dirección de Control
          Escolar.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 135.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          La Dirección de Control Escolar remitirá con toda oportunidad a la
          Coordinación correspondiente, por cada sustentante, los siguientes
          documentos:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <div
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
          <li
            style={{
              margin: "0cm",
              fontSize: "16px",
              fontFamily: '"Times New Roman",serif'
            }}
          >
            <span style={{ fontSize: "16px" }}>Acta de examen.</span>
          </li>
          <li
            style={{
              margin: "0cm",
              fontSize: "16px",
              fontFamily: '"Times New Roman",serif'
            }}
          >
            <span style={{ fontSize: "16px" }}><span style={{ fontSize: "16px" }}>Constancia de examen profesional.</span></span>
          </li>
          <li
            style={{
              margin: "0cm",
              fontSize: "16px",
              fontFamily: '"Times New Roman",serif'
            }}
          >
            <span style={{ fontSize: "16px" }}>Certificados completos de los estudios cursados.</span>
          </li>
        </ol>
      </div>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 136.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Hasta que esté totalmente integrado el expediente del interesado, con la
          documentación que se haya detallado en las distintas formas de titulación,
          el Director de Control Escolar autorizará la fecha y hora para el examen
          recepcional o la ceremonia de titulación, según corresponda, siendo estas
          indiferibles.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>TÍTULO SEXTO</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO ÚNICO</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>Del servicio social</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 137.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Los estudiantes de la Institución prestarán un servicio social con
          carácter temporal y obligatorio, como requisito previo para obtener el
          título que corresponda a nivel de Licenciatura.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 138.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          La prestación de este servicio, por ser de naturaleza social, no podrá
          emplearse para cubrir necesidades de tipo laboral, ni otorgará categoría
          de trabajador al prestador.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 139.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Para que el estudiante preste su servicio social, deberá comprobar
          previamente haber cubierto cuando menos el 70% de los créditos académicos
          del plan de estudios, a menos que cursen programas de salud y áreas
          afines, en cuyo caso, deberán cubrir el 100% de los créditos con que
          cuente el programa de estudios.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 140.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Para efectos de este Reglamento se consideran como auxiliares de la
          Subdirección de Servicio Social, a:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Los Coordinadores de las diversas escuelas o carreras de la Institución.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Los maestros titulares de cátedras en donde se establezcan adjuntías.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Los maestros integrantes de los seminarios que tengan como función el
            dirigir la elaboración de tesis o memorias.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Todo el organismo institucional.</span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 141.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Los maestros a que se refiere este capítulo tendrán como funciones, las
          siguientes:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Proporcionar a los alumnos y pasantes la asesoría de su especialidad en
            los niveles operacionales correspondientes, de acuerdo con las
            necesidades del trabajo y aplicación que los programas de servicio
            social requieran.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Informar mensualmente a la Subdirección de Servicio Social el desarrollo
            de los trabajos de los alumnos y pasantes a su cargo, ya sea que laboren
            individualmente o en grupo.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Supervisar las investigaciones o trabajos que realicen los alumnos o
            pasantes, de cuyas deficiencias o incumplimiento se informará
            oportunamente a la Subdirección de Servicio Social.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Asistir a las juntas convocadas por la Subdirección con objeto de
            programar y organizar la formación de grupos o brigadas de servicio
            social.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            En general, todas aquellas que a juicio de la Subdirección se consideren
            necesarias para el mejor cumplimiento de su cometido.&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 142.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Para inscribirse como alumno o pasante en el servicio social es necesario
          satisfacer los siguientes requisitos:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Presentar la solicitud ante la Subdirección de Servicio Social.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Adjuntar constancia o certificado de estudios.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Anexar 4 fotografías tamaño credencial.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Llenar cédula de datos generales.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Anexar carta de pasante.&nbsp;</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Entregar constancia de aceptación expedida por el organismo, institución
            o dependencia en la cual se acredite que el alumno o pasante va a
            prestar el servicio social.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Formular plan de trabajo o programa de actividades.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Los demás que a juicio de la Subdirección se consideren
            necesarios.&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 143.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El carácter de alumno o pasante en servicio social se acreditará con las
          constancias de iniciación que expida la Subdirección.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 144.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El tiempo de prestación de servicio social de los alumnos o pasantes,
          empezarán a contar a partir de la fecha en que la Subdirección reconozca
          la iniciación de dicho servicio.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 145.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Los asuntos relacionados con la prestación del servicio social solo podrán
          ser tratados en forma personal por los interesados.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 146.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El servicio social podrá prestarse en las siguientes formas:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>Individualmente.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            En grupos o brigadas específicas de una sola especialidad.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            En grupos o brigadas de dos o más especialidades
            (multidisciplinario).&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 147.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Previa aprobación del Rector, el servicio social podrá prestarse en grupo
          o en brigadas, llevando a cabo el estudio coordinado y la solicitud de
          problemas de distintas índoles.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 148.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Cada grupo o brigada de servicio social se integrará a iniciativa de
          la Subdirección, o de algún organismo público o privado en los términos
          que establece la fracción IX del artículo 3 de este Reglamento.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 149.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          En cada grupo o brigada de servicio social, uno o más de sus integrantes
          serán designados por la Subdirección para asumir la representación de este
          en calidad de coordinador o de coordinadores.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 150.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;La duración del servicio social no podrá ser menor de 480 horas,
          durante un lapso no menor de 6 meses ni mayor de 2 años.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 151.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          La duración del servicio social para alumnos que cursen programas de salud
          y áreas afines será de 12 meses continuos, con una duración de 960 horas y
          se efectuará en los lugares que para ese efecto tenga disponibles la
          Secretaría de Salud.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 152.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          No se computará en el término anterior el tiempo que por enfermedad u otra
          causa grave, el estudiante permanezca fuera del lugar en que deba prestar
          el servicio social.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 153.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Toda vez que la calidad y la intensidad del servicio social es variable y
          los criterios para valorarlo pueden diferir en función de la naturaleza
          del mismo, podrá reducirse el tiempo de duración señalado en el artículo
          anterior, previa solicitud del interesado y por acuerdo conjunto del
          Subdirector del Servicio Social y el Coordinador de que proceda el alumno
          o pasante. El Coordinador respectivo deberá oír dictamen del encargado del
          seminario de tesis o memoria correspondiente. &nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 154.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Los estudiantes trabajadores de la federación y del gobierno del
          Estado, no estarán obligados a prestar ningún servicio social distinto al
          desempeño de sus funciones.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 155.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Son obligaciones de los alumnos y pasantes durante la prestación del
          servicio social.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Llevar a cabo todas las investigaciones, estudios y trabajos
            encomendados por la Subdirección de Servicio Social, los maestros
            titulares, coordinadores o responsables designados y acatar las órdenes
            e instrucciones que estos indiquen.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Rendir periódicamente informes pormenorizados a la Subdirección de
            Servicio Social, en los formatos que esta proporcione con el visto bueno
            del titular responsable o del coordinador, describiendo en ellos la
            actividad o actividades desarrolladas, el método empleado en la
            realización de los trabajos y la solución completa que en su caso se
            proponga a los problemas analizados.&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 156.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Los alumnos y pasantes que durante la prestación del servicio social
          violen las disposiciones de este reglamento, serán sancionados con la
          suspensión provisional de dicho servicio.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 157.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Los casos no previstos en este Reglamento sobre el servicio social serán
          discrecionalmente resueltos por la Subdirección, de acuerdo con el
          Rector.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>TÍTULO SÉPTIMO&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>CAPÍTULO ÚNICO</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>De las becas</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 158.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          La Institución, consciente de su responsabilidad social, establece el
          presente capítulo que tiene por objeto normar el otorgamiento de becas a
          sus alumnos.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 159.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;En atención a las posibilidades presupuestales y la condición
          económica del solicitante, las becas que se concedan podrán ser:
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Beca alfa, que comprende la totalidad de la inscripción y de la
            colegiatura semestral en un cien por ciento.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Beca beta, que comprende solo un determinado porcentaje, que será
            asignado por el Comité de Becas.&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 160.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El otorgamiento de una beca, cualquiera que sea el monto de esta, atenderá
          fundamentalmente al mérito académico y a las necesidades económicas del
          solicitante, independientemente de su sexo, ideología o creencia
          religiosa.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 161.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          El porcentaje mínimo de becas concedidas será el 5% del total de los
          alumnos inscritos en cada programa académico.&nbsp;
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 162.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          En el porcentaje antes señalado no se incluirán aquellas que se encuentren
          destinadas a los hijos del personal, ni aquellas que sean otorgadas a
          instituciones públicas o privadas.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 163.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>Existen tres tipos de becas:</span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>De primera vez.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>De renovación.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>De incremento.</span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 164.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Los requisitos para la obtención de becas de primera vez y de incremento
          serán los siguientes:&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>Ser alumno de la Institución.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Presentar solicitud por escrito dentro de los términos y plazos
            establecidos en la convocatoria y anexen la documentación comprobatoria
            que se señale en la misma.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Tener un promedio general no menor de 9.0 (nueve) en sus estudios del
            nivel inmediato anterior y no adeudar ninguna asignatura.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Haber demostrado satisfactoriamente, a juicio del Comité de Becas, la
            carencia de recursos económicos que le imposibiliten continuar
            estudiando; esto, mediante el estudio socioeconómico que realice la
            Institución por conducto del área de trabajo social; estudio que se
            llevará a cabo en el domicilio y entorno social del alumno.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>Demostrar buena conducta.</span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Ser mexicano por nacimiento o naturalización.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Haber tenido una asistencia a clases no menor del 90%, salvo causa
            debidamente justiciada.
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 165.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          La duración de las becas será por un semestre, de acuerdo con el
          calendario oficial de la Institución y podrán renovarse de manera
          automática siempre que se cumplan los siguientes requisitos:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Haber aprobado en examen ordinario todas las materias correspondientes
            al semestre anterior, con un promedio mínimo de 9.0 (nueve).
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Haber tenido una asistencia a clases mínima del 90%, salvo causa
            debidamente justificada.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Comprobar que se cumplió con las demás obligaciones de becario en forma
            satisfactoria.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            El becario al que se le renueve la beca gozará del derecho de
            preferencia sobre nuevos solicitantes.
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 166.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Procede la cancelación de la beca en los siguientes casos:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Por haber proporcionado información falsa.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Por dejar de cumplir cualquiera de las obligaciones como becario, sin
            causa justificada.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Cuando el rendimiento académico baje de los límites establecidos.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Por haber sido sancionado con suspensión o expulsión del plantel
            respectivo.&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 167.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Todos los becarios tendrán las siguientes obligaciones:
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Dedicarse en tiempo completo a las actividades académicas del semestre
            en el que se encuentran inscritos.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Cursar la totalidad de la carga académica determinada por las
            asignaturas de su semestre.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Asistir con puntualidad en día y hora a todas sus clases.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Aprobar todas sus asignaturas del semestre.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Observar buena conducta dentro y fuera de la Institución.
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify",
          textIndent: "-21.75pt"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          color: "black",
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 168.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px", fontFamily: '"Times New Roman",serif' }}>
          La convocatoria para el otorgamiento de becas se expedirá por el Comité de
          Becas, 60 días antes de que concluya el ciclo escolar, la que se difundirá
          en los lugares públicos de la Institución y en su página electrónica.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          color: "black",
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px", fontFamily: '"Times New Roman",serif' }}>
          &nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          color: "black",
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px", fontFamily: '"Times New Roman",serif' }}>
          Dicha convocatoria deberá contener:&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          color: "black",
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px", fontFamily: '"Times New Roman",serif' }}>
            &nbsp;
          </span>
        </strong>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontFamily: '"Times New Roman",serif', fontSize: "16px" }}>
            Los requisitos por cubrir por parte de los solicitantes;&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontFamily: '"Times New Roman",serif', fontSize: "16px" }}>
            Los tipos de beca a otorgar;
          </span>
        </li>
        <li>
          <span style={{ fontFamily: '"Times New Roman",serif', fontSize: "16px" }}>
            Los plazos de entrega y recepción de los formatos de solicitud de
            becas;&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontFamily: '"Times New Roman",serif', fontSize: "16px" }}>
            Los plazos, lugares y forma en que deben realizarse los trámites;
          </span>
        </li>
        <li>
          <span style={{ fontFamily: '"Times New Roman",serif', fontSize: "16px" }}>
            Las formas en que se efectuarán los estudios socioeconómicos;
          </span>
        </li>
        <li>
          <span style={{ fontFamily: '"Times New Roman",serif', fontSize: "16px" }}>
            Los lugares donde podrán realizarse los estudios socioeconómicos, en su
            caso;&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontFamily: '"Times New Roman",serif', fontSize: "16px" }}>
            Los procedimientos para la selección, asignación y entrega de
            resultados;&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontFamily: '"Times New Roman",serif', fontSize: "16px" }}>
            Las condiciones para la conservación, renovación y, en su caso,
            supuestos para la cancelación de becas, y&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontFamily: '"Times New Roman",serif', fontSize: "16px" }}>
            La forma y plazos para que los aspirantes que no obtengan la beca
            presenten su inconformidad.
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 169.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px", color: "black" }}>
          La Institución distribuirá gratuitamente en sus Instalaciones o, en su
          caso, a través de su página electrónica, los formatos de solicitud de beca
          de acuerdo con sus calendarios y publicará la convocatoria en los términos
          establecidos en este reglamento.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px", color: "black" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 170.</span>
        </strong>
        <span style={{ fontSize: "16px", color: "black" }}>
          &nbsp;La Institución notificará a los interesados los resultados de la
          asignación de becas, conforme a lo establecido en la convocatoria
          respectiva.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 171.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Para conocer y resolver el otorgamiento de becas y el seguimiento de los
          becarios, se constituye el Comité de Becas que estará integrado por un
          Presidente y un Secretario nombrados por el Rector, considerando
          exclusivamente al personal directivo del plantel, así como también un
          número de vocales determinado por las autoridades de la Institución que
          representará, en igual número, al personal docente y a los estudiantes, y
          serán elegidos por la comunidad que representan.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 172.</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          &nbsp;Una vez integrado el Comité, el Presidente y el Secretario se
          encargarán de convocarlo asegurándose de su correcto funcionamiento y
          ejecutando las determinaciones del mismo; dicho Comité debe reunirse
          cuando menos 2 veces en un ciclo escolar.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 173.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>
          Las sesiones del Comité se celebrarán con la presencia cuando menos de la
          mitad de sus miembros y las decisiones se adoptarán por mayoría de votos
          de los miembros. El Secretario del Comité no tiene derecho a voto y el
          Presidente tendrá voto de calidad solo en caso de empate.
        </span>
      </p>
      <p
        style={{
          marginTop: "0cm",
          marginRight: "0cm",
          marginBottom: "0cm",
          marginLeft: "0",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif'
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}> Artículo 174.&nbsp;</span>
        </strong>
        <span style={{ fontSize: "16px" }}>Son atribuciones del Comité:</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;</span>
      </p>
      <ol style={{ listStyleType: "upper-roman", marginLeft: "20px" }}>
        <li>
          <span style={{ fontSize: "16px" }}>
            Diseñar, aprobar y expedir la convocatoria para el concurso de selección
            de becarios, a más tardar 60 días antes de la terminación del ciclo
            lectivo.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Diseñar, aprobar, reproducir y distribuir gratuitamente la forma para
            solicitud de beca de primera vez y de renovación.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            El Comité deberá tomar en cuenta el promedio final de calificaciones del
            solicitante y la situación económica de su familia.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Seleccionar a los nuevos becarios y autorizar la renovación
            correspondiente.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Determinar el porcentaje de beca que se otorgue a cada uno de los
            alumnos seleccionados.&nbsp;
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            Entregar por escrito los resultados a los solicitantes de beca, además
            de publicar una relación de los alumnos becados en un lugar de fácil
            acceso y visible para la comunidad escolar.
          </span>
        </li>
        <li>
          <span style={{ fontSize: "16px" }}>
            La entrega de los resultados de becas para el semestre será de 10 días
            hábiles después de haberse celebrado el concurso de selección.
          </span>
          <br />
          <span style={{ fontSize: "16px" }}>
            El alumno podrá impugnar la decisión a través del recurso de inconformidad
            previsto en los artículos 58 y 59 de este reglamento.
          </span>
        </li>
        <li >
          <span style={{ fontSize: "16px" }}>
            Informar los resultados del proceso a la Secretaría de Educación
            Pública. &nbsp;&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px" }}>&nbsp;&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px", color: "black" }}>
            T R A N S I T O R I O S :
          </span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "center"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px", color: "black" }}>&nbsp;</span>
        </strong>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px", color: "black" }}>Primero.</span>
        </strong>
        <span style={{ fontSize: "16px", color: "black" }}>
          &nbsp;El presente reglamento entrará en vigor al día siguiente de su
          publicación en la página electrónica oficial del Centro Hidalguense de
          Estudios Superiores, previa aprobación por parte de la Secretaría de
          Educación Pública.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px", color: "black" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px", color: "black" }}>Segundo.</span>
        </strong>
        <span style={{ fontSize: "16px", color: "black" }}>
          &nbsp;Quedan derogadas todas las disposiciones anteriores que se opongan
          al presente reglamento.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px", color: "black" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px", color: "black" }}>Tercero.</span>
        </strong>
        <span style={{ fontSize: "16px", color: "black" }}>
          &nbsp;Este reglamento es por tiempo indefinido y solo podrá ser modificado
          por el Consejo de Administración del Centro Hidalguense de Estudios
          Superiores, previa aprobación por parte de la Secretaría de Educación
          Pública de Hidalgo.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px", color: "black" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px", color: "black" }}>Cuarto.</span>
        </strong>
        <span style={{ fontSize: "16px", color: "black" }}>
          &nbsp;Los casos no previstos en este reglamento serán resueltos por el
          Consejo de Administración del Centro Hidalguense de Estudios Superiores,
          con sujeción a las disposiciones legales aplicables.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px", color: "black" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <strong>
          <span style={{ fontSize: "16px", color: "black" }}>Quinto.</span>
        </strong>
        <span style={{ fontSize: "16px", color: "black" }}>
          &nbsp;El presente reglamento norma los estudios realizados de las
          Licenciaturas en Derecho, Ciencias de la Comunicación, Contaduría,
          Administración de Empresas, Psicología, Administración de Empresas
          Turísticas y Diseño Gráfico, conforme a la vigencia de los Reconocimientos
          de Validez Oficial de Estudios, por tanto, los estudiantes podrán hacer
          valer cualquier acción para su beneficio con sustento en las presentes
          disposiciones.&nbsp;
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px", color: "black" }}>&nbsp;</span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px", color: "black" }}>
          El presente reglamento fue aprobado por la Dirección General de Educación
          Superior de la Secretaría de Educación Pública, a los once días del mes de
          septiembre del año dos mil veintitrés.
        </span>
      </p>
      <p
        style={{
          margin: "0cm",
          fontSize: "16px",
          fontFamily: '"Times New Roman",serif',
          marginLeft: "0",
          textAlign: "justify"
        }}
      >
        <span style={{ fontSize: "16px", color: "black" }}>&nbsp;</span>
      </p>
    </div>
  </>
)

export default normatividadPage
